import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatHeading } from "blocks-nextjs/blocks-react/components/Heading/Heading";
import React from "react";
import APIError from "../APIError/APIError";
import ConnectorCard from "./ConnectorCard";
const ChargerLiveView = ({ chargerDetails, isError, isLoading, onRefresh, onViewChargeHistory }) => {
    // Get connectors data
    const connectors = chargerDetails?.connectors || [];
    const connector1 = connectors[0];
    const connector2 = connectors[1];
    // Format duration to "X hr Y minutes"
    const formatDuration = (value, unit) => {
        if (value === undefined || value === null || !unit)
            return "N/A";
        if (unit === "minutes") {
            const hours = Math.floor(value / 60);
            const minutes = value % 60;
            if (hours > 0 && minutes > 0) {
                return `${hours} hr ${minutes} minutes`;
            }
            else if (hours > 0) {
                return `${hours} hr`;
            }
            else {
                return `${minutes} minutes`;
            }
        }
        return `${value} ${unit}`;
    };
    return (_jsxs("div", { "data-test": "charger-live-view", children: [_jsx("div", { className: "flex justify-between items-center mb-4 mt-4", children: _jsx(CatHeading, { "data-test": "live-view-title", variant: "title-sm", children: "Live View" }) }), isError ? (_jsx(APIError, { refreshHandler: () => onRefresh?.() })) : (_jsxs("div", { className: "grid grid-cols-1 xl:grid-cols-2 gap-4", "data-test": "connectors-grid", children: [_jsx(ConnectorCard, { connector: connector1, connectorNumber: 1, formatDuration: formatDuration, isLoading: isLoading, onViewChargeHistory: onViewChargeHistory }), _jsx(ConnectorCard, { connector: connector2, connectorNumber: 2, formatDuration: formatDuration, isLoading: isLoading, onViewChargeHistory: onViewChargeHistory })] }))] }));
};
export default ChargerLiveView;
